import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PerspectiveRegular from './perspective-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PerspectiveRegular {...validProps} />;
}
SvgComponent.iconName = 'perspectiveRegular';

export const PerspectiveRegularIcon = svgIconWrapper(SvgComponent);
